import type RiskFactorsRepository from "@/core/compliance/repositories/RiskFactorsRepository";
import type { RiskFactors } from "@/core/compliance/entities/RiskFactors";
import type { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import l1ReviewEndpoints from "../../api/l1ReviewEndpoints/l1ReviewEndpoints";
import { type RiskFactorsDto, mapRiskFactorsDtoToEntity } from "./mappers";

export default class RiskFactorsRepositoryBackend
  implements RiskFactorsRepository
{
  constructor(private readonly httpClient: HttpClient) {}

  async getRiskFactors(
    reviewId: string,
  ): Promise<RepositoryResult<RiskFactors>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<RiskFactorsDto>>({
          url: l1ReviewEndpoints.riskFactors(reviewId),
          withAuth: true,
        }),
      mapRiskFactorsDtoToEntity,
    );
  }
}
